import { ReactNode } from 'react';

import { IconPhoneFilled } from '@iwoca/icons';
import { Text } from '@iwoca/orion-ui';
import { maintainStateKey } from '@iwRouter/LocationHelper';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { SummaryRow } from '../SummaryRow/SummaryRow';

export const DesktopLoanSummary = ({
    continueButton
}: {
    continueButton: ReactNode;
}) => {
    return (
        <div className="relative grow basis-0 bg-primary-10 text-white">
            {/* Offset by navbar height (72px) */}
            <div className="sticky bottom-0 top-[72px] min-h-[calc(100dvh-72px)] max-w-[472px] p-2xl">
                <Text className="text-m font-reg text-structure-100">
                    <FormattedMessage
                        id="_.loan_summary.min_monthly_repayment"
                        defaultMessage="Min. monthly repayment"
                    />
                </Text>
                <Text className="text-m font-med text-structure-100">
                    <FormattedMessage
                        id="_.loan_summary.min_monthly_repayment_desktop"
                        defaultMessage="{amount} per month"
                        values={{
                            amount: (
                                <span className="text-3xl font-bold">
                                    £--.--
                                </span>
                            )
                        }}
                    />
                </Text>
                <div className="mt-l flex flex-col gap-m border-t border-secondary-20 pt-l">
                    <SummaryRow
                        label={
                            <FormattedMessage
                                id="_.loan_summary.full_term"
                                defaultMessage="Full term:"
                            />
                        }
                        value={
                            <FormattedMessage
                                id="_.loan_summary.default_full_term_value"
                                defaultMessage="- months"
                            />
                        }
                    />
                    <SummaryRow
                        label={
                            <FormattedMessage
                                id="_.loan_summary.interest_rate"
                                defaultMessage="Interest rate /30 days:"
                            />
                        }
                        value="-.--%"
                    />
                    <SummaryRow
                        label={
                            <FormattedMessage
                                id="_.loan_summary.fees"
                                defaultMessage="Fees:"
                            />
                        }
                        value="£-"
                    />
                    <SummaryRow
                        label={
                            <FormattedMessage
                                id="_.loan_summary.total_repayment"
                                defaultMessage="Total repayment:"
                            />
                        }
                        value="£--.--"
                    />
                </div>

                <div className="mt-5xl border-t border-secondary-20 pt-xl">
                    <Text className="font-bold text-structure-100">
                        <FormattedMessage
                            id="_.loan_summary.need_help"
                            defaultMessage="Need some help?"
                        />
                    </Text>
                    <div className="flex items-center gap-m pb-xl pt-s">
                        <IconPhoneFilled fontSize="24px" />
                        <div>
                            <Text className="font-bold text-structure-100">
                                <FormattedMessage
                                    id="_.loan_summary.phone_number"
                                    defaultMessage="020 3778 0105"
                                />
                            </Text>
                            <Text className="font-reg text-structure-100">
                                <FormattedMessage
                                    id="_.loan_summary.phone_hours"
                                    defaultMessage="Monday to Friday (9am - 6pm)"
                                />
                            </Text>
                        </div>
                    </div>
                    <Text className="text-s text-structure-100">
                        <FormattedMessage
                            id="_.loan_summary.upload_docs_prompt"
                            defaultMessage="Been asked to upload additional docs? {link}"
                            values={{
                                link: (
                                    <Link
                                        to={maintainStateKey({
                                            pathname: '/trading'
                                        })}
                                        className="font-bold underline"
                                    >
                                        <FormattedMessage
                                            id="_.loan_summary.upload_docs_link"
                                            defaultMessage="Upload docs"
                                        />
                                    </Link>
                                )
                            }}
                        />
                    </Text>
                </div>

                <div className="mt-xl">{continueButton}</div>
            </div>
        </div>
    );
};
